import React from "react";
import { Redirect, Route, Switch } from "polyrouter";
import Devices from "./Inventory/Devices";
import DeviceActions from "./Actions/DeviceActions";
import { SiteRouter } from "./Sites/SiteRouter";
import RoomsRouter from "./Rooms/RoomsRouter";
import DeviceUsersRouter from "./DeviceUsers/DeviceUsersRouter";
import { ProtectedRoute } from "TsRoleGuards";
import RegisterDecisionFlow from "./Register/RegisterDecisionFlow";
import { PolicyRouter } from "./Policy/PolicyRouter";
import DeviceGroupsRouter from "./DeviceGroups/DeviceGroupsRouter";
import { LicensingRouter } from "./Licensing/LicensingRouter";
import { all, any, needs } from "rbac";
import { ResourceFiles } from "./ResourceFiles/ResourceFiles";
import { useFeatureFlagWithTenant } from "elements";

let ManageRouter = () => {
  const [areResourceFilesEnabled] = useFeatureFlagWithTenant("RESOURCE_FILES");

  return (
    <Switch nest>
      <ProtectedRoute
        path="/inventory"
        component={Devices}
        requirement="read:device"
      />
      <Route path="/actions" component={DeviceActions} />
      <ProtectedRoute
        path="/sites"
        component={SiteRouter}
        requirement={all([needs("READ_TENANT"), needs("READ_SITES")])}
      />
      <ProtectedRoute
        path="/register"
        component={RegisterDecisionFlow}
        requirement="register:device"
      />
      <Route path="/policy" component={PolicyRouter} />
      <ProtectedRoute
        path="/rooms"
        component={RoomsRouter}
        requirement={all([needs("READ_TENANT"), needs("READ_SITES")])}
      />
      <ProtectedRoute
        path="/device-users"
        component={DeviceUsersRouter}
        requirement="READ_USERS"
      />
      <ProtectedRoute
        path="/licensing"
        component={LicensingRouter}
        requirement={any([
          needs("get:polypluslicense"),
          needs("license:ReadTenant")
        ])}
      />
      <ProtectedRoute
        path="/device-groups"
        component={DeviceGroupsRouter}
        requirement="READ_SITES"
      />
      {areResourceFilesEnabled && (
        <ProtectedRoute
          path="/resource-files"
          requirement="read:device:resource:file"
        >
          <ResourceFiles />
        </ProtectedRoute>
      )}
      <ProtectedRoute nest path="/" requirement="read:device">
        <Redirect nest to="inventory" />
      </ProtectedRoute>
    </Switch>
  );
};

export default ManageRouter;
